import { render, staticRenderFns } from "./firstCustomerList.vue?vue&type=template&id=f9995dd8&scoped=true"
import script from "./firstCustomerList.vue?vue&type=script&lang=js"
export * from "./firstCustomerList.vue?vue&type=script&lang=js"
import style0 from "./firstCustomerList.vue?vue&type=style&index=0&id=f9995dd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9995dd8",
  null
  
)

export default component.exports